//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "configuration/properties",
  "./template/tableOfContentsLevelListTemplate.html",
  "./template/tableOfContentsLevelItemTemplate.html",
], function (
  Marionette,
  $,
  Messenger,
  Properties,
  TableOfContentsLevelListTemplate,
  TableOfContentsLevelItemTemplate,
) {
  "use strict";

  var TableOfContentsLevelView = {};

  TableOfContentsLevelView.itemView = Marionette.ItemView.extend({
    className: "table-of-contents-level",
    tagName: "tr",
    template: TableOfContentsLevelItemTemplate,
    triggers: {
      "click .level-move-down-button": "level:move:down",
      "click .level-move-up-button": "level:move:up",
      "click .level-remove-button": "level:remove",
    },
  });

  TableOfContentsLevelView.listView = Marionette.CompositeView.extend({
    template: TableOfContentsLevelListTemplate,
    itemView: TableOfContentsLevelView.itemView,
    itemViewContainer: "tbody",
    triggers: {
      "click .add-level-button": "level:add",
    },
    onDomRefresh: function () {
      $(".add-level-select", this.$el).select2({
        allowClear: true,
        placeholder: $.t("admin.tableOfContents.addLevelPlaceholder"),
      });
    },
    getCategoryId: function () {
      var value = $(".add-level-select", this.$el).val();
      if (!value) {
        return 0;
      }
      return +value;
    },
  });

  return TableOfContentsLevelView;
});
